export const getDifferenceDaysPipe = (endDate: number, startDate?: number): number | string => {
    const secondInHour = 3600;
    const hourInDay = 24;
    const currentDate = startDate ? new Date(startDate * 1000) : new Date();
    const dueDate = new Date(endDate * 1000);
    const result = dueDate.getTime() - currentDate.getTime();
    const differenceDays = result / (1000 * secondInHour * hourInDay);

    if (differenceDays < 0) {
        return '-';
    }

    return Math.round(differenceDays);
};

export default getDifferenceDaysPipe;
